import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Container } from "react-bootstrap";
import { FormGroup, Input, Label } from "reactstrap";
import { Redirect, useHistory, Link } from "react-router-dom";
import axios from "axios";
import { UserConsumer } from "../../../../UserContext";
import Edit from "../../../../images/edit.svg";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { tableStyle } from "../../../../components/TableStyle";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Table } from "../../../../components/CustomPaginations";
import CustomeSearchBar from "../../../../components/CustomeSearchBar";
import Header from "../../../../components/Header";
import { AlertPopups } from "../../../../components/AlertPopups";
import { Routes } from "../../../../configurations/config";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../../components/GlobalPaginationSize";

const ItemRequisitionClasses = () => {
	const history = useHistory();
	let token,
		empDesignation = null;
	const getColumns = [
		{
			dataField: "name",
			text: "Name",
			sort: true,
			formatter: (cell, row) => {
				return (
					<abbr title={row.name}>
						{row.name?.length > 30
							? row.name.slice(0, 30) + "..."
							: row.name}
					</abbr>
				);
			},
		},
		{
			dataField: "code",
			text: "Code",
			sort: true,
		},
		{
			dataField: "description",
			text: "Description",
			 title: true ,
			sort: true,
			formatter: (cell, row) => {
				return (
					<abbr title={row.description}>
						{row.description?.length > 30
							? row.description.slice(0, 30) + "..."
							: row.description}
					</abbr>
				);
			},
		},
		{
			dataField: "status",
			text: "Status",
			formatter: (status) => {
				return status ? "Active" : "Inactive";
			},
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<div style={{ textAlign: "center" }}>
						<Link
							to={Routes.ItemRequisitionClasses}
							onClick={() => {
								getSpecificClassRecord(row.id);
							}}
						>
							<img
								style={{ height: "20px", width: "20px" }}
								src={Edit}
								alt="Edit"
								title="Modify Category"
							/>
						</Link>
					</div>
				);
			},
		},
	];
	const initialValues = {
		name: "",
		code: "",
		description: "",
		status: false,
	};
	const defaultSorted = [
		{
			dataField: "name",
			order: "asc",
		},
	];
	const [createNewClass, setCreateNewClass] = useState(initialValues);
	const [listOfClasses, setListOfClasses] = useState([]);
	const [recordId, setRecordId] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [isLoading, setIsLoading] = useState(true);
	const [updateRecord, setUpdateRecord] = useState(false);
	const [pagerData, setPagerData] = useState(null);
	const [searchInput, setSearchInput] = useState("");
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);

	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);
		//Get table data
		getListOfItemRequisitionClasses();
	}, []);

	const getListOfItemRequisitionClasses = (searchTerm = "") => {
		setSearchInput(searchTerm.trimStart());
		axios
			.get(
				`${
					ItemRequisitionAPI.GetItemRequisitionClasses
				}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}${searchTerm ? "&SearchTerm=" + searchTerm.trimStart() : ""}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data, headers }) => {
				setIsLoading(false);
				setPagerData(JSON.parse(headers["x-pagination"]));
				setListOfClasses(data["classes"]);
			});
	};
	const handleChange = (e) => {
		setCreateNewClass({
			...createNewClass,
			[e.target.name]: e.target.value,
		});
	};
	const handleSubmit = () => {
		const body = {
			code: createNewClass.code,
			name: createNewClass.name,
			description: createNewClass.description,
			status: createNewClass.status,
		};
		axios
			.post(`${ItemRequisitionAPI.GetItemRequisitionClasses}`, body, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				AlertPopups.successAlert.fire({
					text: "Class Added Successfully",
				});

				getListOfItemRequisitionClasses();
				setCreateNewClass(initialValues);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message} `,
					});
				}
			});
	};
	const handleReset = () => {
		setCreateNewClass(initialValues);
	};
	const getSpecificClassRecord = (id) => {
		setRecordId(id);
		setUpdateRecord(true);
		axios
			.get(`${ItemRequisitionAPI.GetItemRequisitionClasses}/${id}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setCreateNewClass({
					code: data.code,
					name: data.name,
					description: data.description,
					status: data.status,
				});
			});
	};
	const handleUpdate = () => {
		if (createNewClass.code === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Code",
			});

			return;
		}
		if (createNewClass.name === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Name",
			});

			return;
		}
		const body = {
			code: createNewClass.code,
			name: createNewClass.name,
			description: createNewClass.description,
			status: createNewClass.status,
		};
		if (recordId) {
			axios
				.put(
					`${ItemRequisitionAPI.GetItemRequisitionClasses}/${recordId}`,
					body,
					{ headers: { Authorization: `Bearer ${token}` } }
				)
				.then(({ data }) => {
					AlertPopups.successAlert.fire({
						text: "Record Update Successfully",
					});
					setSearchInput(" ");

					handleReset();
					setUpdateRecord(false);
					getListOfItemRequisitionClasses();
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
					}
				});
		}
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let apiURL = "";
		let getData = false;

		if (type === "sort") {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionClasses}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionClasses}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setListOfClasses(res.data["classes"]);
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
					}
				});
		}
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = "";

		apiURL = `${
			ItemRequisitionAPI.GetItemRequisitionClasses
		}?PageNumber=${1}&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${
			sortBy.order
		}`;

		axios
			.get(apiURL, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setIsLoading(false);
				setNumberOfItemsPerPage(PageSize);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setListOfClasses(res.data["classes"]);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	const rowEvents = {
		onClick: (e, row) => {
			getSpecificClassRecord(row.id);
			history.push({
				pathname: Routes.ItemRequisitionClasses,
			});
		},
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "33" ||
					userDetails.empRole.includes("3") ? (
					<Container fluid className="mt-3">
						<Header
							title="Classes"
							headerBorder="true"
							navigateBack={() =>
								history.push(Routes.ItemRequisition)
							}
						/>
						<Form className="item-requisition-classes-form">
							<Label className="formInfoContainerHeader">
								Class Details
							</Label>
							<Row className="d-flex align-items-center item-requisition-classes-fbody">
								<Col lg={3}>
									<FormGroup className="classes-form-group">
										<Label className="mr-3 form-lable formFieldsHeading">
											Code
											<span className="required">*</span>
										</Label>
										<Input
											name="code"
											type="number"
											onChange={handleChange}
											value={createNewClass.code}
											className="classes-inputs h-auto formValueInput"
										/>
									</FormGroup>
								</Col>
								<Col lg={3}>
									<FormGroup className="classes-form-group">
										<Label className="mr-3 form-lable formFieldsHeading">
											Name
											<span className="required">*</span>
										</Label>
										<Input
											name="name"
											onChange={handleChange}
											value={createNewClass.name}
											className="classes-inputs h-auto formValueInput"
										/>
									</FormGroup>
								</Col>
								<Col lg={3}>
									<FormGroup className="classes-form-group">
										<Label className="mr-3 form-lable formFieldsHeading">
											Description
											<span className="required">*</span>
										</Label>
										<Input
											type="textarea"
											rows={2}
											name="description"
											onChange={handleChange}
											value={createNewClass.description}
											className="classes-inputs formValueInput"
										/>
									</FormGroup>
								</Col>
								<Col lg={2}>
									<Form.Group
										className="classes-form-group"
										style={{ justifyContent: "flex-start" }}
									>
										<Form.Label className="mr-3 form-lable formFieldsHeading">
											Active
										</Form.Label>
										<Form.Control
											type="checkbox"
											name="status"
											checked={createNewClass.status}
											onChange={() => {
												setCreateNewClass({
													...createNewClass,
													status: !createNewClass.status,
												});
											}}
											className="classes-inputs formValueInput"
											style={{ height: "20px" }}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									{!updateRecord ? (
										<>
											<Button
												className="classes-resetBtn"
												onClick={handleReset}
											>
												Reset
											</Button>
											<Button
												className="classes-saveBtn"
												onClick={handleSubmit}
											>
												Create
											</Button>
										</>
									) : (
										<>
											<Button
												className="classes-resetBtn"
												onClick={() => {
													setUpdateRecord(false);
													handleReset();
												}}
											>
												Undo
											</Button>
											<Button
												className="classes-updateBtn"
												onClick={handleUpdate}
											>
												Update
											</Button>
										</>
									)}
								</Col>
							</Row>
						</Form>
						<CustomeSearchBar
							inputValue={searchInput}
							handleSearch={(event) =>
								getListOfItemRequisitionClasses(
									event.target.value
								)
							}
							tooltip={"Search by name, code and description"}
						/>
						{pagerData ? (
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: listOfClasses.length,
									page: pagerData?.CurrentPage,
									sizePerPage: pagerData?.PageSize,
									paginationSize: pagerData?.PageSize,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"id"}
											columns={getColumns}
											items={listOfClasses}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											pagerData={pagerData}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						) : (
							<Table
								inputValue={""}
								keyField={"id"}
								columns={getColumns}
								items={listOfClasses}
								tableStyle={tableStyle}
								defaultSorted={sortBy}
								showFeedback={false}
								tableLoader={isLoading}
								SearchBar={() => {
									return null;
								}}
							/>
						)}
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default ItemRequisitionClasses;
